import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import checkedRoundIcon from '../../../../commons/src/assets/icons/checked-round.svg'
import chevronRight from '../../../../commons/src/assets/icons/chevron-right.svg'

import Icon from '../../../../commons/src/components/icon'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    image: React.ReactNode
    title: React.ReactNode
    subtitle?: React.ReactNode
    counter?: number
    link?: React.ReactNode
    checked?: boolean
    active?: boolean
    activeLabel?: string
    action?: React.ReactNode
    onClick?: React.MouseEventHandler
    selected?: boolean
    stripe?: boolean
  }
>

const MaterialActivationItem = ({
  className,
  image,
  title,
  subtitle,
  counter,
  link,
  checked = false,
  active = false,
  activeLabel,
  action,
  onClick,
  selected = false,
  stripe = false,
  ...props
}: Props) => {
  const handleOnItemClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (
      !(event.target as HTMLElement).closest('a') &&
      !(event.target as HTMLElement).closest('button')
    ) {
      if (onClick) {
        onClick(event)
      }
    }
  }

  return (
    <div
      {...props}
      className={cn(
        'MaterialActivationItem',
        {selected, stripe, hasAction: !!action, hoverEnabled: !!link && !!subtitle, checked},
        className
      )}
      onClick={handleOnItemClick}
    >
      <div className="MaterialActivationItem__left">
        <div className="MaterialActivationItem__image">{image}</div>
        <div className="MaterialActivationItem__content">
          <div className="MaterialActivationItem__title">
            <span className="MaterialActivationItem__name">{title}</span>
            {counter && <span>({counter})</span>}
          </div>
          {subtitle && <div className="MaterialActivationItem__subtitle">{subtitle}</div>}
          {link && <div className="MaterialActivationItem__link">{link}</div>}
        </div>
      </div>
      <div className="MaterialActivationItem__right">
        {!!activeLabel && (
          <span className="MaterialActivationItem__activeLabel">{activeLabel}</span>
        )}
        {(active || checked) && (
          <span className="MaterialActivationItem__checkmark">
            <Icon source={checkedRoundIcon} />
          </span>
        )}
        {action ? (
          action
        ) : (
          <button type="button" onClick={onClick}>
            <Icon source={chevronRight} />
          </button>
        )}
      </div>
    </div>
  )
}

export default MaterialActivationItem
